// src/components/store/sections/weekly-banner/Variant3MinimalLuxe.tsx
"use client";

import Image from "next/image";
import Link from "next/link";
import { ArrowRight, Tag } from "lucide-react";
import { WeeklyBannerProps } from "./types";

export default function Variant3MinimalLuxe({ banner, subdomain }: WeeklyBannerProps) {
  const imageUrl = banner?.image
    ? banner.image.startsWith("http") || banner.image.startsWith("data:")
      ? banner.image
      : `http://${subdomain ? `${subdomain}.` : ""}localhost:8000${banner.image.startsWith("/") ? "" : "/"}${banner.image}`
    : "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800&auto=format&fit=crop&q=80";

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 select-none font-sans">
      <div className="rounded-[32px] bg-slate-900 border-2 border-slate-700/80 p-8 sm:p-12 flex flex-col md:flex-row items-center justify-between gap-8 overflow-hidden relative shadow-xl group transition-all">
        <div className="space-y-4 max-w-xl z-10 text-left">
          <span className="text-[10px] font-black text-amber-400 uppercase tracking-widest inline-flex items-center gap-1.5 bg-amber-950/40 border border-amber-500/40 px-3 py-1 rounded-md">
            <Tag className="w-3 h-3" />
            {banner?.badge_title || "FEATURED COLLECTION"}
          </span>

          <h2 className="text-2xl sm:text-4xl font-extrabold text-white tracking-tight leading-snug">
            {banner?.title || "Modern Essentials Curated For You"}
          </h2>

          <p className="text-xs sm:text-sm text-slate-400 leading-relaxed max-w-md font-normal">
            {banner?.subtitle ||
              "Explore premium grade selections engineered with unmatched durability and timeless aesthetics."}
          </p>

          <div className="pt-2">
            <Link
              href={banner?.target_url || "/products"}
              className="px-7 py-3 rounded-xl bg-white hover:bg-slate-200 text-slate-950 font-black text-xs inline-flex items-center gap-2 transition-all shadow-md active:scale-95 cursor-pointer"
            >
              <span>{banner?.button_text || "Discover More"}</span>
              <ArrowRight className="w-4 h-4 text-slate-950" />
            </Link>
          </div>
        </div>

        <div className="w-64 sm:w-[380px] aspect-[4/3] relative flex-shrink-0 flex items-center justify-center">
          <Image
            src={imageUrl}
            alt={banner?.title || "Weekly Banner"}
            fill
            unoptimized
            className="object-contain drop-shadow-2xl group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </div>
    </section>
  );
}

export { Variant3MinimalLuxe };